export default __webpack_public_path__ + "static/media/halas13.d4974b50.jpg";